// src/components/AddCartButton/AddCartButton.tsx

import React from 'react';
import { BaseCartButton } from './BaseCartButton';
import { Product } from '../../api-client';

interface AddCartButtonProps {
  product: Product;
  quantity: number;
  selectedSizeId: number | null;
  selectedColorId: number | null;
  stock: number;
  onStockUpdate?: (colorId: number, sizeId: number, newStock: number) => void; // Añadimos esta prop
}

export const AddCartButton: React.FC<AddCartButtonProps> = ({ 
  product,
  quantity,
  selectedSizeId,
  selectedColorId,
  stock,
  onStockUpdate  // Añadimos esta prop
}) => {
  return (
    <BaseCartButton
      product={product}
      quantity={quantity}
      selectedSizeId={selectedSizeId}
      selectedColorId={selectedColorId}
      stock={stock}
      onSuccess={(colorId, sizeId, newStock) => {
        if (onStockUpdate) {
          onStockUpdate(colorId, sizeId, newStock);
        }
      }}
      buttonText="Add to Cart"
      variant="secondary"
    />
  );
};
